import { render } from "./exwarehousehb95.vue?vue&type=template&id=dd23a9ec"
import script from "./exwarehousehb95.vue?vue&type=script&lang=js"
export * from "./exwarehousehb95.vue?vue&type=script&lang=js"

import "./exwarehousehb95.vue?vue&type=style&index=0&id=dd23a9ec&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__